import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContractors = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.22,11.87a.29.29,0,0,1-.17-.23.26.26,0,0,1,.16-.24,3.21,3.21,0,1,0-2.52,0,.26.26,0,0,1,.16.24.29.29,0,0,1-.17.23A4,4,0,0,0,0,15.61v3a.49.49,0,0,0,.49.49h.89a.25.25,0,0,1,.24.23L2,23.55a.49.49,0,0,0,.49.45h3a.49.49,0,0,0,.49-.45l.36-4.26a.25.25,0,0,1,.24-.23h.89a.49.49,0,0,0,.49-.49v-3A4,4,0,0,0,5.22,11.87Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.32,11.87a.29.29,0,0,1-.17-.23.26.26,0,0,1,.16-.24,3.21,3.21,0,1,0-2.52,0,.26.26,0,0,1,.16.24.29.29,0,0,1-.17.23,4,4,0,0,0-2.68,3.74v3a.49.49,0,0,0,.49.49h.89a.25.25,0,0,1,.24.23l.36,4.26a.49.49,0,0,0,.49.45h3a.49.49,0,0,0,.49-.45l.36-4.26a.25.25,0,0,1,.24-.23h.89a.49.49,0,0,0,.49-.49v-3A4,4,0,0,0,21.32,11.87Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.17,5.64A.26.26,0,0,1,13,5.41a.25.25,0,0,1,.14-.24,2.72,2.72,0,1,0-2.3,0,.25.25,0,0,1,.14.24.26.26,0,0,1-.16.23A3.46,3.46,0,0,0,8.54,8.89v1.48a.51.51,0,0,0,.15.35.5.5,0,0,0,.35.14h.82a.25.25,0,0,1,.24.22l.42,3.79a.5.5,0,0,0,.49.44h2a.5.5,0,0,0,.49-.44l.42-3.79a.25.25,0,0,1,.24-.22H15a.49.49,0,0,0,.5-.49V8.89A3.46,3.46,0,0,0,13.17,5.64Z",
			fill: "currentColor"
		})
	] })
});
export { SvgContractors as ReactComponent };
